import(/* webpackMode: "eager", webpackExports: ["Banner"] */ "/vercel/path0/src/components/banner/banner.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FaqFr"] */ "/vercel/path0/src/components/fr/faqFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportedPlatformsFr"] */ "/vercel/path0/src/components/fr/supportedPlatformsFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetLivePlaygroundFr"] */ "/vercel/path0/src/components/fr/widgetLivePlaygroundFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetSpokeHeroFr"] */ "/vercel/path0/src/components/fr/widgetSpokeHeroFr.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyUseWidget"] */ "/vercel/path0/src/components/whyUseWidget/whyUseWidget.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetFeatures"] */ "/vercel/path0/src/components/widgetFeatures/widgetFeatures.comp.tsx");
